export default __webpack_public_path__ + "static/media/ic-print-white.ee6f4a7d.svg";